// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const delcatty: PokeData = {
  "id": 301,
  "name": "delcatty",
  "height": 11,
  "weight": 326,
  "base_experience": 140,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "double-slap",
    "tackle",
    "double-edge",
    "tail-whip",
    "growl",
    "sing",
    "fury-swipes",
    "charm",
    "attract",
    "heal-bell",
    "fake-out",
    "facade",
    "covet",
    "payback",
    "copycat",
    "disarming-voice",
    "play-rough",
    "baby-doll-eyes"
  ],
  "moves": [
    "tackle",
    "growl",
    "heal-bell",
    "play-rough",
    "leer",
    "scary-face",
    "scratch",
    "splash",
    "purification",
    "tri-attack",
    "protect",
    "quick-attack",
    "body-slam"
  ],
  "evolution_chain": {
    "id": 148,
    "item": null,
    "species": [
      {
        "name": "skitty",
        "order": 326,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "delcatty",
        "order": 327,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 300,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 118,
    "speed": 164,
    "ability_power": 118
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
